import { FluentBundle, } from "@fluent/bundle";
import { negotiateLanguages } from "@fluent/langneg";
import { createSvelteFluent, initFluentContext as initFluentContextCore } from "@nubolab-ffwd/svelte-fluent";

import translationsDe from "../Localization/de-CH.ftl";
import translationsFr from "../Localization/fr-CH.ftl";

const resources = {
	de: translationsDe,
	fr: translationsFr,
};
const supportedLocales = Object.keys(resources);

const selectedLocales = negotiateLanguages([document.documentElement.lang, ...navigator.languages], supportedLocales, {
	defaultLocale: "de",
	strategy: "lookup"
}) as ("de" | "fr")[];

export const language = selectedLocales[0];

const bundles = selectedLocales.map(locale => {
	const bundle = new FluentBundle(locale);
	bundle.addResource(resources[locale]);
	return bundle;
});

export { Localized, Overlay } from "@nubolab-ffwd/svelte-fluent";

export const svelteFluent = createSvelteFluent(bundles);
export const initFluentContext = () => initFluentContextCore(() => svelteFluent);
export const localize = svelteFluent.localize.bind(svelteFluent);
